import Layout from 'components/Layout/Layout'
import Preloader from 'components/Preloader/Preloader'
import Section, { SectionType } from 'components/Section/Section'
import { Colour } from 'components/variables'
import * as React from 'react'

interface LoaderProps {
  colour?: Colour
}

const Loader: React.FC<LoaderProps> = ({ colour }) => (
  <Layout color={colour}>
    <Section type={SectionType.solid}>
      <Preloader hidden={false} />
    </Section>
  </Layout>
)

export default Loader
